import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
//import Card from "@mui/material/Card";
import MKTypography from "components/MKTypography";
// Material Kit 2 React components
import MKBox from "components/MKBox";
//import MKTypography from "components/MKTypography";
//import MKSocialButton from "components/MKSocialButton";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
// Material Kit 2 React examples
//import FilledInfoCard from "examples/Cards/InfoCards/FilledInfoCard";
import { Button, TextField } from "@mui/material";
import { SEND_EMAIL } from "../queries";
//import DesignBlocks from "pages/Presentation/sections/DesignBlocks";
//import Pages from "pages/Presentation/sections/Pages";
//import Testimonials from "pages/Presentation/sections/Testimonials";
//import Download from "pages/Presentation/sections/Download";

// Presentation page components
//import BuiltByDevelopers from "pages/Presentation/components/BuiltByDevelopers";

// Routes
//import routes from "routes";
//import Information from "./Information";
// Images
import bgImage from "assets/images/contact.png";
import { useMutation } from "@apollo/client";
//import { ALL_MUNICIPALITIES } from "queries";
import ReCAPTCHA from "react-google-recaptcha";
/* eslint-disable react/prop-types */
// eslint-disable-next-line
const Contact = ({ setError, selectedKunta, setSelectedKunta }) => {
  //const Strategy = ({ selectedKunta, setSelectedKunta }) => {
  //console.log(selectedKunta);
  //console.log(setSelectedKunta);
  const [t] = useTranslation("common");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [matter, setMatter] = useState("");
  //const [newComment, setNewComment] = useState("");
  const [verified, setVerified] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  // eslint-disable-next-line
  const [executing, setExecuting] = useState(false);
  //console.log(setExecuting);
  const [sendEmail] = useMutation(SEND_EMAIL, {
    onError: (error) => {
      //console.log("virhe meilin lähetyksessä:" + error);
      //setEmailerror(true);
      //setError(error.graphQLErrors[0].message)
      setError(error);
    },
    /*update: (store, response) => {
      updateCacheWith(response.data.addComment)
    }*/
  });

  const addComment = () => {
    //event.preventDefault();
    sendEmail({
      variables: {
        to: "kunta.livehosting@gmail.com",
        header: "Kunta.live -  ota yhteyttä",
        text: "Name:" + name + "/ Phone: " + phone + "/ Email: " + email + "/ Asia: " + matter,
      },
      //"Kiitos rekisteröitymisestä / Thank you for registering / Tack för din registrering"
    });
    /*createComment({
      content: newComment,
      important: false,
    })
    */
    setSubmitted(true);
  };
  // eslint-disable-next-line
  function onChange(value) {
    //console.log("Captcha value:", value);
    setVerified(!verified);
  }
  if (submitted) {
    return (
      <>
        <MKBox
          minHeight="23vh"
          width="100%"
          sx={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "2500px 250px",
            backgroundPosition: "top",
            display: "grid",
            placeItems: "center",
          }}
        />
        <MKBox pt={6} px={1} mt={6}>
          <Container>
            <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
              <MKTypography
                variant="h1"
                color="black"
                mt={-6}
                mb={1}
                sx={({ breakpoints, typography: { size } }) => ({
                  [breakpoints.down("md")]: {
                    fontSize: size["3xl"],
                  },
                })}
              >
                <h2>{t("contact.header")}</h2>
              </MKTypography>
              <MKTypography
                variant="body1"
                color="black"
                textAlign="center"
                px={{ xs: 6, lg: 12 }}
                mt={1}
              >
                {t("common.formok")}
              </MKTypography>
            </Grid>
          </Container>
        </MKBox>
      </>
    );
  } else {
    return (
      <>
        <MKBox
          minHeight="23vh"
          width="100%"
          sx={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "2500px 250px",
            backgroundPosition: "top",
            display: "grid",
            placeItems: "center",
          }}
        />
        <MKBox pt={6} px={1} mt={6}>
          <Container>
            <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
              <MKTypography
                variant="h1"
                color="black"
                mt={-6}
                mb={1}
                sx={({ breakpoints, typography: { size } }) => ({
                  [breakpoints.down("md")]: {
                    fontSize: size["3xl"],
                  },
                })}
              >
                <h2>{t("contact.header")}</h2>
              </MKTypography>
              <MKTypography
                variant="body1"
                color="black"
                textAlign="center"
                px={{ xs: 6, lg: 12 }}
                mt={1}
              >
                <form onSubmit={addComment}>
                  {t("common.name")}
                  <TextField onChange={(e) => setName(e.target.value)} value={name} />
                  <br />
                  <br />
                  {t("common.phone")}
                  <TextField onChange={(e) => setPhone(e.target.value)} value={phone} />
                  <br />
                  <br />
                  {t("common.email")}
                  <TextField value={email} onChange={(e) => setEmail(e.target.value)} />
                  <br />
                  <br />
                  {t("common.thing")}
                  <TextField
                    multiline
                    fullWidth
                    minRows={3}
                    value={matter}
                    onChange={(e) => setMatter(e.target.value)}
                    variant="outlined"
                    style={{ marginBottom: "0.5rem" }}
                    inputProps={{ maxLength: 500 }}
                  />
                  <br />
                  <br />
                  <div>
                    <ReCAPTCHA
                      sitekey="6Lf6wLIaAAAAAORH1jwBkpv1NzwvaBYa9mpn39GP"
                      onChange={onChange}
                    />
                  </div>
                  <br />
                  <br />
                  <Button
                    style={{ backgroundColor: "#07575B", color: "#C4DFE6", fontSize: "14px" }}
                    type="submit"
                    disabled={!verified}
                    executing={executing}
                    submitted={submitted}
                  >
                    {submitted ? t("common.done") : executing ? "Verifying" : t("common.send")}
                  </Button>
                  <br />
                  <br />
                </form>
                <p>{t("contact.text")}</p>
              </MKTypography>
            </Grid>
          </Container>
        </MKBox>
      </>
    );
  }
};

export default Contact;
